// LIST
export const FETCH_CARE_HOME_GROUPS =
  "app/CareHomeGroups/FETCH_CARE_HOME_GROUPS";
export const FETCH_CARE_HOME_GROUPS_SUCCESS =
  "app/CareHomeGroups/FETCH_CARE_HOME_GROUPS_SUCCESS";
export const FETCH_CARE_HOME_GROUPS_FAILURE =
  "app/CareHomeGroups/FETCH_CARE_HOME_GROUPS_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/CareHomeGroups/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/CareHomeGroups/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/CareHomeGroups/GET_VIEW_DATA_FAILURE";
// ADD
export const ADD_CARE_HOME_GROUP = "app/CareHomeGroups/ADD_CARE_HOME_GROUP";
export const ADD_CARE_HOME_GROUP_SUCCESS =
  "app/CareHomeGroups/ADD_CARE_HOME_GROUP_SUCCESS";
export const ADD_CARE_HOME_GROUP_FAILURE =
  "app/CareHomeGroups/ADD_CARE_HOME_GROUP_FAILURE";
// EDIT
export const EDIT_CARE_HOME_GROUP = "app/CareHomeGroups/EDIT_CARE_HOME_GROUP";
export const EDIT_CARE_HOME_GROUP_SUCCESS =
  "app/CareHomeGroups/EDIT_CARE_HOME_GROUP_SUCCESS";
export const EDIT_CARE_HOME_GROUP_FAILURE =
  "app/CareHomeGroups/EDIT_CARE_HOME_GROUP_FAILURE";
// DELETE
export const DELETE_CARE_HOME_GROUP =
  "app/CareHomeGroups/DELETE_CARE_HOME_GROUP";
export const DELETE_CARE_HOME_GROUP_SUCCESS =
  "app/CareHomeGroups/DELETE_CARE_HOME_GROUP_SUCCESS";
export const DELETE_CARE_HOME_GROUP_FAILURE =
  "app/CareHomeGroups/DELETE_CARE_HOME_GROUP_FAILURE";
// SEARCH
export const SEARCH_CARE_HOME_GROUP =
  "app/CareHomeGroups/SEARCH_CARE_HOME_GROUP";
export const SEARCH_CARE_HOME_GROUP_SUCCESS =
  "app/CareHomeGroups/SEARCH_CARE_HOME_GROUP_SUCCESS";
export const SEARCH_CARE_HOME_GROUP_FAILURE =
  "app/CareHomeGroups/SEARCH_CARE_HOME_GROUP_FAILURE";

// PRINT COMPANY CODE
export const GENERATE_COMPANY_CODE = "app/CareHomeGroups/GENERATE_COMPANY_CODE";
export const GENERATE_COMPANY_CODE_SUCCESS =
  "app/CareHomeGroups/GENERATE_COMPANY_CODE_SUCCESS";
export const GENERATE_COMPANY_CODE_FAILURE =
  "app/CareHomeGroups/GENERATE_COMPANY_CODE_FAILURE";

// PRINT COMPANY ADDRESS
export const GENERATE_COMPANY_ADDRESS =
  "app/CareHomeGroups/GENERATE_COMPANY_ADDRESS";
export const GENERATE_COMPANY_ADDRESS_SUCCESS =
  "app/CareHomeGroups/GENERATE_COMPANY_ADDRESS_SUCCESS";
export const GENERATE_COMPANY_ADDRESS_FAILURE =
  "app/CareHomeGroups/GENERATE_COMPANY_ADDRESS_FAILURE";

// INVITE COMPANY ADMINISTRATOR
export const TOGGLE_INVITE_MODAL = "app/CareHomeGroups/TOGGLE_INVITE_MODAL";
export const INVITE_COMPANY = "app/CareHomeGroups/INVITE_COMPANY";
export const INVITE_COMPANY_SUCCESS =
  "app/CareHomeGroups/INVITE_COMPANY_SUCCESS";
export const INVITE_COMPANY_FAILURE =
  "app/CareHomeGroups/INVITE_COMPANY_FAILURE";

// DIRECT COMPANY CLAIM
export const TOGGLE_DIRECT_CLAIM_MODAL =
  "app/CareHomeGroups/TOGGLE_DIRECT_CLAIM_MODAL";
export const DIRECT_CLAIM_COMPANY = "app/CareHomeGroups/DIRECT_CLAIM_COMPANY";
export const DIRECT_CLAIM_COMPANY_SUCCESS =
  "app/CareHomeGroups/DIRECT_CLAIM_COMPANY_SUCCESS";
export const DIRECT_CLAIM_COMPANY_FAILURE =
  "app/CareHomeGroups/DIRECT_CLAIM_COMPANY_FAILURE";
